export default __webpack_public_path__ + "static/media/slide7.fd541dd9.webp";